// Intersection Observer for animations
document.addEventListener('DOMContentLoaded', function() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);

    // Observe sections for fade-in animation
    const sections = document.querySelectorAll('section');
    sections.forEach(section => {
        section.style.opacity = '0';
        section.style.transform = 'translateY(20px)';
        section.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(section);
    });
});

// Button click handlers for external links
document.addEventListener('DOMContentLoaded', function() {
    const externalButtons = document.querySelectorAll('.btn');
    
    externalButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            const buttonText = this.textContent.trim();
            
            // Handle different button actions
            if (buttonText.includes('Learn More About Soles4Souls')) {
                window.open('https://soles4souls.org/', '_blank');
            } else if (buttonText.includes('Learn More About Shoe Lab')) {
                window.open('https://www.shoelab.co.uk/', '_blank');
            } else if (buttonText.includes('Learn More About RedPoints')) {
                window.open('https://www.redpoints.com/', '_blank');
            } else if (buttonText.includes('Donate Items')) {
                window.open('https://soles4souls.org/?form=give', '_blank')
            } else if (buttonText.includes('Get your Items Cleaned')) {
                window.open('https://www.shoelab.co.uk/products/')
            } else if (buttonText.includes('Report Fake Sellers')) {
                alert('Redirecting to Red Points reporting system...');
            } else if (buttonText.includes('Request Partnership')) {
                window.location.href = 'https://sidekicks.co.uk/pages/faqs/';
            }
        });
    });
});

// Lazy loading for images
document.addEventListener('DOMContentLoaded', function() {
    const images = document.querySelectorAll('img');
    
    const imageObserver = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                img.style.opacity = '1';
                imageObserver.unobserve(img);
            }
        });
    });

    images.forEach(img => {
        img.style.opacity = '0';
        img.style.transition = 'opacity 0.3s ease';
        img.addEventListener('load', function() {
            this.style.opacity = '1';
        });
        imageObserver.observe(img);
    });
});

// Partner cards carousel and step indicators
document.addEventListener('DOMContentLoaded', function() {
    const partnerCardsGrid = document.querySelector('.partner-cards-grid');
    const steps = document.querySelectorAll('.step-indicator .step');
    let currentIndex = 0;

    if (partnerCardsGrid && steps.length > 0) {
        // Update step indicators based on scroll position
        function updateStepIndicators() {
            const cardWidth = partnerCardsGrid.offsetWidth;
            const scrollPosition = partnerCardsGrid.scrollLeft;
            const newIndex = Math.round(scrollPosition / cardWidth);

            if (newIndex !== currentIndex && newIndex >= 0 && newIndex < steps.length) {
                steps[currentIndex].classList.remove('active');
                steps[newIndex].classList.add('active');
                currentIndex = newIndex;
            }
        }

        // Update indicators on scroll
        partnerCardsGrid.addEventListener('scroll', () => {
            requestAnimationFrame(updateStepIndicators);
        });
    }
});

// Initialize responsive image handling

// Performance optimization: Debounced resize handler
let resizeTimeout;
window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
        // Handle any resize-specific logic here
    }, 250);
});